export default "/assets/comments-blankstate-fe0630474387153812f40af1ec63e45a93101175ca02e4530b7b9c3001ca6098.svg";